import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { SheetTemplatesService } from 'src/app/services/sheet-templates.service';
import { clientErrored } from '../error/error.actions';
import { AppState } from '../reducers';
import * as sheetTemplateManagementActions from './sheet-template-management.actions';

@Injectable()
export class SheetTemplateManagementEffects {

	constructor(private actions$: Actions, private store: Store<AppState>, private sheetTemplatesService: SheetTemplatesService, private errorService: ErrorService) {
	}

	loadTemplatesRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(sheetTemplateManagementActions.loadTemplatesRequested),
			mergeMap(() => this.sheetTemplatesService.getTemplates().pipe(
				map(templates => sheetTemplateManagementActions.loadTemplatesCompleted({ templates })),
				catchError((error: HttpErrorResponse) => of(clientErrored({ toastMessage: 'Load sheet templates failed', errorMessage: this.errorService.getErrorMessage(error) })))
			))
		)
	);

	renameTemplateRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(sheetTemplateManagementActions.renameTemplateRequested),
			mergeMap(action => this.sheetTemplatesService.updateName(action.templateId, action.newName).pipe(
				map(template => sheetTemplateManagementActions.renameTemplateCompleted({ template })),
				catchError((error: HttpErrorResponse) => of(clientErrored({ toastMessage: 'Rename template failed', errorMessage: this.errorService.getErrorMessage(error) })))
			))
		)
	);

	changeTemplateActiveStateRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(sheetTemplateManagementActions.changeTemplateActiveStateRequested),
			mergeMap(action => this.sheetTemplatesService.updateActiveState(action.templateId, action.isActive).pipe(
				map(template => sheetTemplateManagementActions.changeTemplateActiveStateCompleted({ template })),
				catchError((error: HttpErrorResponse) => of(clientErrored({ toastMessage: 'Change template active state failed', errorMessage: this.errorService.getErrorMessage(error) })))
			))
		)
	);

	deleteTemplateRequested$ = createEffect(() =>
		this.actions$.pipe(
			ofType(sheetTemplateManagementActions.deleteTemplateRequested),
			mergeMap(action => this.sheetTemplatesService.deleteTemplate(action.templateId).pipe(
				map(() => sheetTemplateManagementActions.deleteTemplateCompleted({ templateId: action.templateId })),
				catchError((error: HttpErrorResponse) => of(clientErrored({ toastMessage: 'Delete template failed', errorMessage: this.errorService.getErrorMessage(error) })))
			))
		)
	);
}

